/**
 * Helpers de câmbio (exchange rates vindos da API).
 *
 * A API retorna uma lista de taxas; cada item tem `targetCurrencyInitials`
 * (ex.: "USD") e `value`. Várias telas do funil (busca → reserva → confirmação)
 * precisam da taxa USD para converter preços para BRL.
 *
 * Antes este lookup era copiado inline em ~6 lugares como
 * `exchangeRates.find(...).value`, SEM guard — se a lista viesse vazia/sem USD
 * (câmbio do dia indisponível), o `.value` lançava TypeError e derrubava a tela
 * inteira (tela branca) no meio do fluxo de reserva. Centralizar aqui com guard
 * resolve as 6 ocorrências (C-03).
 */

/**
 * Retorna o valor numérico da taxa de câmbio para a moeda informada, ou null se
 * a lista estiver vazia/indefinida ou não contiver a moeda.
 *
 * @param {Array<{targetCurrencyInitials:string,value:number}>} exchangeRates
 * @param {string} [currency="USD"]
 * @returns {number|null}
 */
export const getExchangeRate = (exchangeRates, currency = "USD") => {
	// Defensivo: o estado inicial do orderReducer traz exchangeRates como {} (não
	// array), então não basta `|| []` — usamos Array.isArray (como o CurrencyBox).
	const list = Array.isArray(exchangeRates) ? exchangeRates : [];
	const result = list.find((item) => item && item.targetCurrencyInitials === currency);
	return result && result.value != null ? result.value : null;
};

/** Atalho para a taxa USD (caso de uso dominante: compra no Brasil). */
export const getUsdRate = (exchangeRates) => getExchangeRate(exchangeRates, "USD");

export default getUsdRate;
